import uaParser from 'ua-parser-js';

import { DEVICE_OS, DEVICE_PLATFORM } from '../constants/device';

const parser = typeof window !== 'undefined' ? new uaParser() : null;

interface props {
  ios: string;
  android: string;
  other: string;
}

const getDeviceOS = (customValue?: props) => {
  const os = parser !== null ? parser.getResult().os.name : null;

  if (customValue) {
    switch (os) {
      case DEVICE_OS.IOS:
        return customValue[DEVICE_OS.IOS];
      case DEVICE_OS.ANDROID:
        return customValue[DEVICE_OS.ANDROID];
      default:
        return customValue[DEVICE_OS.OTHER];
    }
  } else {
    switch (os) {
      case 'iOS':
        return DEVICE_OS.IOS;
      case 'Android':
        return DEVICE_OS.ANDROID;
      default:
        return DEVICE_OS.OTHER;
    }
  }
};

const getDevicePlateForm = () => {
  if (getDeviceOS() === DEVICE_OS.OTHER) {
    return DEVICE_PLATFORM.DESKTOP;
  } else {
    return DEVICE_PLATFORM.MOBILE;
  }
};

const getDeviceType = () => {
  const useragent = navigator.userAgent;
  const rules = [
    'WebView',
    '(iPhone|iPod|iPad)(?!.*Safari/)',
    'Android.*(wv|.0.0.0)',
    'Autopass/(.*)',
  ];
  const regex = new RegExp(`(${rules.join('|')})`, 'ig');
  const isMatch = Boolean(useragent.match(regex));
  if (isMatch) {
    return 'in-app-webview';
  } else {
    return 'browser';
  }
};

const getBrowser = () => {
  return parser?.getBrowser().name;
};

const inWebview = () => {
  const useragent = navigator.userAgent;
  const regex = new RegExp('Autopass/(.*)', 'ig');
  return Boolean(useragent.match(regex));
};

const isAppleDevice = () => {
  const device = ['iPhone', 'iPad', 'Mac'];
  return device.find(
    (d) =>
      navigator.platform.indexOf(d) !== -1 || navigator.platform.includes(d),
  );
};

const isAndroidDevice = () => {
  return getDeviceOS() === DEVICE_OS.ANDROID;
};

export {
  getBrowser,
  getDeviceOS,
  getDevicePlateForm,
  getDeviceType,
  inWebview,
  isAndroidDevice,
  isAppleDevice,
};
